<script>
import compoment from '@/components/draggable/SmartComponents/basicComponents/Sinput/SInputEditor'
export default {
  name: 'SLinkEditor',
  extends: compoment
}
</script>
